/**
 * Sticky Add to Cart - Mobile Only
 * Shows a fixed Add to Cart button at the bottom of the screen when user scrolls past the original button
 * Includes size picker
 */

(function() {
  'use strict';
  
  function initStickyAddToCart() {
    console.log('[StickyATC] Initializing...');
    
    // Only initialize on mobile (< 750px)
    if (window.innerWidth >= 750) {
      console.log('[StickyATC] Desktop detected, skipping initialization');
      return;
    }
    
    // Find the original button - try multiple selectors
    const originalButton = document.querySelector('.product-form__submit') || 
                          document.querySelector('[name="add"][type="submit"]') ||
                          document.querySelector('button[data-product-id]');
    
    if (!originalButton) {
      console.log('[StickyATC] No Add to Cart button found');
      return;
    }
    
    console.log('[StickyATC] Found button:', originalButton);
    
    // Check if sticky bar already exists
    if (document.querySelector('.sticky-add-to-cart')) {
      console.log('[StickyATC] Sticky bar already exists');
      return;
    }
    
    // Get product variants data
    const variantsData = getProductVariants();
    const sizeOptions = getSizeOptions(variantsData);
    
    // Create sticky bar container
    const stickyBar = document.createElement('div');
    stickyBar.className = 'sticky-add-to-cart';
    stickyBar.setAttribute('aria-hidden', 'true');
    
    // Create size picker if sizes are available
    if (sizeOptions && sizeOptions.length > 1) {
      const sizePicker = createSizePicker(sizeOptions, variantsData);
      stickyBar.appendChild(sizePicker);
    }
    
    // Clone the button
    const clonedButton = originalButton.cloneNode(true);
    clonedButton.removeAttribute('id');
    clonedButton.classList.add('sticky-add-to-cart__button');
    
    // Track if sticky should be visible based on scroll position
    let shouldBeVisible = false;
    let selectedVariantId = getCurrentVariantId();
    
    // Function to update sticky visibility (considering cart drawer state)
    function updateStickyVisibility() {
      const cartDrawer = document.querySelector('cart-drawer');
      const isCartOpen = cartDrawer && cartDrawer.classList.contains('active');
      
      if (isCartOpen) {
        stickyBar.classList.remove('is-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
        console.log('[StickyATC] Cart drawer open - hiding sticky');
      } else if (shouldBeVisible && window.innerWidth < 750) {
        stickyBar.classList.add('is-visible');
        stickyBar.setAttribute('aria-hidden', 'false');
      }
    }
    
    // Function to open cart drawer
    function openCartDrawer() {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        fetch(window.location.pathname + '?section_id=cart-drawer')
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const newDocument = parser.parseFromString(html, 'text/html');
            const newCartDrawer = newDocument.querySelector('cart-drawer');
            
            if (newCartDrawer && cartDrawer) {
              cartDrawer.innerHTML = newCartDrawer.innerHTML;
              
              requestAnimationFrame(() => {
                const drawer = cartDrawer.querySelector('.drawer');
                if (drawer) {
                  cartDrawer.classList.add('active');
                  drawer.classList.add('active');
                  updateStickyVisibility();
                  console.log('[StickyATC] Cart drawer opened');
                }
              });
            }
          })
          .catch(error => {
            console.warn('[StickyATC] Failed to update cart drawer:', error);
          });
      }
    }
    
    // Handle click - trigger the original form submission and open cart
    clonedButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      console.log('[StickyATC] Sticky button clicked');
      
      // Update the variant ID in the original form if size was selected
      if (selectedVariantId) {
        const variantInput = document.querySelector('input.product-variant-id, input[name="id"]');
        if (variantInput) {
          variantInput.value = selectedVariantId;
          console.log('[StickyATC] Updated variant ID to:', selectedVariantId);
        }
      }
      
      // Click the original button
      originalButton.click();
      
      // Open cart drawer after a short delay
      setTimeout(openCartDrawer, 500);
    });
    
    stickyBar.appendChild(clonedButton);
    document.body.appendChild(stickyBar);
    
    console.log('[StickyATC] Sticky bar created');
    
    // Function to sync button state
    function syncButtonState() {
      const stickyButton = stickyBar.querySelector('.sticky-add-to-cart__button');
      if (!stickyButton) return;
      
      stickyButton.disabled = originalButton.disabled;
      
      const originalSpan = originalButton.querySelector('span');
      const stickySpan = stickyButton.querySelector('span');
      if (originalSpan && stickySpan) {
        stickySpan.textContent = originalSpan.textContent;
      }
    }
    
    // Initial sync
    syncButtonState();
    
    // Watch for changes to the original button
    const mutationObserver = new MutationObserver(syncButtonState);
    mutationObserver.observe(originalButton, {
      attributes: true,
      childList: true,
      subtree: true
    });
    
    // Watch for cart drawer open/close
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      const cartObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'class') {
            updateStickyVisibility();
          }
        });
      });
      
      cartObserver.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
    
    // Get the element to observe
    const buttonsContainer = originalButton.closest('.product-form__buttons') || originalButton;
    
    // Use Intersection Observer to detect when original button leaves viewport
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (window.innerWidth >= 750) return;
        
        const rect = entry.boundingClientRect;
        
        if (!entry.isIntersecting) {
          if (rect.bottom < 0) {
            shouldBeVisible = true;
            console.log('[StickyATC] Button scrolled above viewport');
            updateStickyVisibility();
          } else {
            shouldBeVisible = false;
            stickyBar.classList.remove('is-visible');
            stickyBar.setAttribute('aria-hidden', 'true');
          }
        } else {
          shouldBeVisible = false;
          stickyBar.classList.remove('is-visible');
          stickyBar.setAttribute('aria-hidden', 'true');
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0
    });
    
    observer.observe(buttonsContainer);
    
    // Handle resize
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (window.innerWidth >= 750) {
          stickyBar.classList.remove('is-visible');
        } else {
          updateStickyVisibility();
        }
      }, 150);
    });
    
    // Listen for variant changes on the page
    document.addEventListener('change', function(e) {
      if (e.target.matches('select[name^="options"], input[type="radio"][name^="options"]')) {
        setTimeout(function() {
          selectedVariantId = getCurrentVariantId();
          syncSizePickerWithPage();
          syncButtonState();
        }, 100);
      }
    });
    
    // Function to sync size picker with page selection
    function syncSizePickerWithPage() {
      const currentVariantId = getCurrentVariantId();
      if (!currentVariantId || !variantsData) return;
      
      const currentVariant = variantsData.find(v => v.id == currentVariantId);
      if (!currentVariant) return;
      
      // Find the size value from the current variant
      const sizeOptionIndex = getSizeOptionIndex();
      if (sizeOptionIndex === -1) return;
      
      const currentSize = currentVariant.options[sizeOptionIndex];
      
      // Update the size picker buttons
      const sizeButtons = stickyBar.querySelectorAll('.sticky-size-btn');
      sizeButtons.forEach(btn => {
        if (btn.dataset.size === currentSize) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });
      
      selectedVariantId = currentVariantId;
    }
    
    // Function to create size picker
    function createSizePicker(sizes, variants) {
      const container = document.createElement('div');
      container.className = 'sticky-size-picker';
      
      const currentVariantId = getCurrentVariantId();
      const currentVariant = variants ? variants.find(v => v.id == currentVariantId) : null;
      const sizeOptionIndex = getSizeOptionIndex();
      const currentSize = currentVariant && sizeOptionIndex !== -1 ? currentVariant.options[sizeOptionIndex] : null;
      
      sizes.forEach(size => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sticky-size-btn';
        btn.textContent = size.value;
        btn.dataset.size = size.value;
        
        if (size.value === currentSize) {
          btn.classList.add('active');
        }
        
        if (!size.available) {
          btn.classList.add('sold-out');
          btn.disabled = true;
        }
        
        btn.addEventListener('click', function() {
          // Remove active class from all buttons
          container.querySelectorAll('.sticky-size-btn').forEach(b => b.classList.remove('active'));
          // Add active class to clicked button
          btn.classList.add('active');
          
          // Find the variant with this size
          const newVariant = findVariantBySize(size.value, variants);
          if (newVariant) {
            selectedVariantId = newVariant.id;
            
            // Also update the main page selector
            updatePageVariant(size.value);
            
            console.log('[StickyATC] Selected size:', size.value, 'Variant ID:', newVariant.id);
          }
        });
        
        container.appendChild(btn);
      });
      
      return container;
    }
    
    // Helper functions
    function getProductVariants() {
      // Try to find variants JSON on the page
      const jsonScript = document.querySelector('variant-selects script[type="application/json"], variant-radios script[type="application/json"]');
      if (jsonScript) {
        try {
          return JSON.parse(jsonScript.textContent);
        } catch (e) {
          console.warn('[StickyATC] Failed to parse variants JSON');
        }
      }
      
      // Fallback: try to get from product info
      const productInfo = document.querySelector('product-info');
      if (productInfo) {
        const variantsScript = productInfo.querySelector('script[type="application/json"]');
        if (variantsScript) {
          try {
            const data = JSON.parse(variantsScript.textContent);
            return data.variants || data;
          } catch (e) {}
        }
      }
      
      return null;
    }
    
    function getSizeOptionIndex() {
      // Find which option index is "Size"
      const optionLabels = document.querySelectorAll('.product-form__input label, fieldset legend');
      let index = -1;
      optionLabels.forEach((label, i) => {
        const text = label.textContent.toLowerCase().trim();
        if (text.includes('size') || text.includes('rozmiar')) {
          // Estimate index based on position
          const parent = label.closest('.product-form__input, fieldset');
          if (parent) {
            const allOptions = document.querySelectorAll('.product-form__input, fieldset.product-form__input');
            allOptions.forEach((opt, optIndex) => {
              if (opt === parent) index = optIndex;
            });
          }
        }
      });
      
      // Fallback: assume Size is option 1 (index 0) if not found
      if (index === -1) {
        const selectElements = document.querySelectorAll('select[name^="options"]');
        selectElements.forEach((select, i) => {
          const label = select.closest('.product-form__input')?.querySelector('label');
          if (label && (label.textContent.toLowerCase().includes('size') || label.textContent.toLowerCase().includes('rozmiar'))) {
            index = i;
          }
        });
      }
      
      return index !== -1 ? index : 0; // Default to first option
    }
    
    function getSizeOptions(variants) {
      if (!variants || variants.length === 0) return null;
      
      const sizeIndex = getSizeOptionIndex();
      const sizes = new Map();
      
      variants.forEach(variant => {
        const sizeValue = variant.options[sizeIndex];
        if (sizeValue && !sizes.has(sizeValue)) {
          sizes.set(sizeValue, {
            value: sizeValue,
            available: variant.available
          });
        } else if (sizeValue && variant.available) {
          // If any variant with this size is available, mark as available
          sizes.get(sizeValue).available = true;
        }
      });
      
      return Array.from(sizes.values());
    }
    
    function getCurrentVariantId() {
      const variantInput = document.querySelector('input.product-variant-id, input[name="id"][type="hidden"]');
      return variantInput ? variantInput.value : null;
    }
    
    function findVariantBySize(sizeValue, variants) {
      if (!variants) return null;
      
      const sizeIndex = getSizeOptionIndex();
      const currentVariantId = getCurrentVariantId();
      const currentVariant = variants.find(v => v.id == currentVariantId);
      
      // Try to find a variant that matches the size and keeps other options the same
      if (currentVariant) {
        const matchingVariant = variants.find(v => {
          if (v.options[sizeIndex] !== sizeValue) return false;
          // Check other options match
          for (let i = 0; i < v.options.length; i++) {
            if (i !== sizeIndex && v.options[i] !== currentVariant.options[i]) {
              return false;
            }
          }
          return true;
        });
        
        if (matchingVariant) return matchingVariant;
      }
      
      // Fallback: just find first available variant with this size
      return variants.find(v => v.options[sizeIndex] === sizeValue && v.available) ||
             variants.find(v => v.options[sizeIndex] === sizeValue);
    }
    
    function updatePageVariant(sizeValue) {
      // Update the main page selector to match
      const sizeIndex = getSizeOptionIndex();
      const selectElements = document.querySelectorAll('select[name^="options"]');
      
      if (selectElements[sizeIndex]) {
        const select = selectElements[sizeIndex];
        const option = Array.from(select.options).find(opt => opt.value === sizeValue);
        if (option) {
          select.value = sizeValue;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      
      // Also try radio buttons
      const radioInputs = document.querySelectorAll(`input[type="radio"][value="${sizeValue}"]`);
      radioInputs.forEach(radio => {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    
    // Initial sync with page
    syncSizePickerWithPage();
    
    console.log('[StickyATC] Initialization complete');
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAddToCart);
  } else {
    setTimeout(initStickyAddToCart, 100);
  }
})();
